import classNames from 'classnames';
import React from 'react';

import { Accordion as BaseAccordion } from '@sravni/react-design-system';

import { AccordionItem } from './AccordionItem';
import styles from './styles.module.scss';

const AccordionComponent: React.FC<React.ComponentProps<typeof BaseAccordion>> & { Item: typeof AccordionItem } = ({
  className,
  ...props
}) => <BaseAccordion {...props} className={classNames(className, styles.accordion)} />;

AccordionComponent.Item = AccordionItem;

export const Accordion = AccordionComponent;
